"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DocumentPlus = void 0;
const react_1 = __importDefault(require("react"));
const react_native_svg_1 = __importStar(require("react-native-svg"));
function DocumentPlus({ size = 80, color = "#3db384" }) {
    return (react_1.default.createElement(react_native_svg_1.default, { width: size, height: size, viewBox: "0 0 105.22 129.5" },
        react_1.default.createElement(react_native_svg_1.Path, { fill: color, d: "M104.51,35.42L69.79,.7c-.45-.45-1.06-.7-1.7-.7H17.24C7.73,0,0,7.73,0,17.23V112.27c0,9.5,7.73,17.23,17.24,17.23H87.97c9.51,0,17.24-7.74,17.24-17.24V37.12c0-.64-.25-1.25-.7-1.7h0ZM70.49,8.2l26.52,26.52h-14.08c-6.86,0-12.44-5.57-12.44-12.43V8.2Zm29.92,104.06c0,6.85-5.58,12.42-12.44,12.42H17.24c-6.86,0-12.43-5.57-12.43-12.42V17.23c0-6.85,5.58-12.43,12.43-12.43h48.45V22.29c0,9.5,7.74,17.23,17.25,17.23h17.48V112.26ZM36.62,45.82v-9.2h9.19c1.33,0,2.4-1.07,2.4-2.4s-1.07-2.4-2.4-2.4h-9.19v-9.18c0-1.33-1.07-2.4-2.4-2.4s-2.4,1.07-2.4,2.4v9.18h-9.18c-1.33,0-2.4,1.07-2.4,2.4s1.07,2.4,2.4,2.4h9.18v9.2c0,1.33,1.07,2.4,2.4,2.4s2.4-1.08,2.4-2.4Zm45.96,36.97H36.86c-1.33,0-2.4,1.08-2.4,2.4s1.07,2.4,2.4,2.4h45.72c1.33,0,2.4-1.08,2.4-2.4,0-1.33-1.08-2.4-2.4-2.4Zm-45.72-18.42c-1.33,0-2.4,1.07-2.4,2.4s1.07,2.4,2.4,2.4h45.72c1.33,0,2.4-1.08,2.4-2.4s-1.07-2.4-2.4-2.4H36.86Zm45.72,36.85H36.86c-1.33,0-2.4,1.07-2.4,2.4s1.07,2.4,2.4,2.4h45.72c1.33,0,2.4-1.07,2.4-2.4,0-1.33-1.08-2.4-2.4-2.4ZM22.63,63.57c-1.77,0-3.2,1.43-3.2,3.2s1.43,3.2,3.2,3.2,3.2-1.43,3.2-3.2-1.43-3.2-3.2-3.2Zm0,18.42c-1.77,0-3.2,1.43-3.2,3.2s1.43,3.2,3.2,3.2,3.2-1.43,3.2-3.2-1.43-3.2-3.2-3.2Zm0,18.42c-1.77,0-3.2,1.43-3.2,3.2s1.43,3.2,3.2,3.2,3.2-1.43,3.2-3.2-1.43-3.2-3.2-3.2Z" })));
}
exports.DocumentPlus = DocumentPlus;
